import { Button, Text, Group, ModalBaseProps, Stack } from "@mantine/core";
import { ModalCenter } from "../atoms/ModalCenter";

interface Props extends Omit<ModalBaseProps, 'title'> {
  modalTitle: string;
  title: string;
  description?: string;
  onDelete: () => void;
}

export const DeleteConfirm = ({ modalTitle, title, description, onDelete, ...props }: Props) => {
  return (
    <ModalCenter title={modalTitle} {...props}>
      <Stack>
        <Text fw="bold">{title}</Text>
        {description && <Text>{description}</Text>}
        <Group justify="end">
          <Button onClick={props.onClose} variant="default">
            Cancel
          </Button>
          <Button color="red" onClick={onDelete}>
            Verwijder
          </Button>
        </Group>
      </Stack>
    </ModalCenter>
  )
}
